import { render, staticRenderFns } from "./AgendasPage.vue?vue&type=template&id=1698ef4e&"
import script from "./AgendasPage.vue?vue&type=script&lang=js&"
export * from "./AgendasPage.vue?vue&type=script&lang=js&"
import style0 from "./AgendasPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
